import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Alert,
  Box,
  Collapse,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

// Your components
import { Close, Login } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { activateAccount } from "apis/controllers/users";
import { jwtDecode } from "jwt-decode";
import TextInput from "qubCommon/Inputs/TextInput";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createMarkup } from "util/createMarkup";
import { useSnackbar } from 'notistack';
import { PASSWORD_REGEX } from "qubCommon/helperMethods/passwordPolicy";



const EmployeeRegisterForm = () => {
  if (import.meta.env.MODE === "development") {
    window.serverData = {
      status: "success",
      data: {
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIwNzQ0OTE5NzgiLCJ1c2VyX2lkIjoiMGQ2MTc4ODUtZGNlMS00MDAyLThlOTMtMWE0MDE5OGRhODZkIiwibmJmIjoxNzY0OTM3ODY0LCJleHAiOjE3NjQ5MzgxNjQsImlhdCI6MTc2NDkzNzg2NH0.zNVKrpcKRg7oT1ypEOeo7T38CQwfiDHVvbLLv0o_6jw",
      },
    };
  }

  const methods = useForm();
  const { handleSubmit } = methods;
  const { enqueueSnackbar } = useSnackbar();

  const [data] = useState(window.serverData || {});
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let decodedData;
  try {
    decodedData = jwtDecode(data?.data?.token);
  } catch (e) {
    console.log(e);
  }

  const onSubmit = async (submitData) => {
    if (loading) return;  // ⛔ block double submits
    setError("");
    try {
      setLoading(true);
      const res = await activateAccount({
        AMKA: submitData?.amka,
        token: data?.data?.token,
        Password: submitData?.password,
        ConfirmPassword: submitData?.confirmPassword
      });
      const { status } = res;
      if (status === "error") {
        setError(res?.message);
      } else if (status === "empty") {
        setError("Παρακαλώ συμπληρώστε τα πεδία.");
      } else {
        enqueueSnackbar(res?.message, { variant: "success" });
        navigate("/govnr/login");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          p: 4,
          maxWidth: 900,
          mx: "auto",
          bgcolor: "#fff",
          borderRadius: 2,
        }}
      >
        {/* Title */}
        <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
          Το TaxisNet σας πιστοποίησε, εισάγετε τον ΑΜΚΑ σας για είσοδο.
        </Typography>

        {/* Warning Box */}
        <Alert
          severity="error"
          icon={false}
          sx={{
            mb: 3,
            bgcolor: "secondary.main",
            color: "white",
            fontWeight: 500,
          }}
        >
          «Όποιος εν γνώσει του δηλώνει ψευδή γεγονότα ή αρνείται ή αποκρύπτει
          τα αληθή με έγγραφη υπεύθυνη δήλωση του άρθρου 8 τιμωρείται με
          φυλάκιση τουλάχιστον τριών μηνών. Εάν ο υπαίτιος αυτών των πράξεων
          σκοπείται να προσπορίσει στον εαυτόν του ή σε άλλον περιουσιακό όφελος
          βλάπτοντας τρίτον ή σκοπεί να βλάψει άλλον, τιμωρείται με κάθειρξη
          μέχρι 10 ετών.»
        </Alert>

        {/* Form */}
        <Grid container spacing={3}>
          {/* ΑΦΜ */}
          <Grid item xs={12} md={6}>
            <TextInput
              id="afm"
              name="afm"
              label="ΑΦΜ"
              isFullWidth
              rules={{ required: "Απαιτείται ΑΦΜ" }}
              disabled
              defaultValue={decodedData?.nameid}
            />
          </Grid>

          {/* ΑΜΚΑ */}
          <Grid item xs={12} md={6}>
            <TextInput
              id="amka"
              name="amka"
              label="ΑΜΚΑ"
              isFullWidth
              rules={{ required: "Απαιτείται ΑΜΚΑ" }}
            />
          </Grid>

          {/* Password */}

          <Grid item xs={12} md={6}>
            <TextInput
              type={showPass ? "text" : "password"}
              label="Κωδικός Πρόσβασης"
              fullWidth
              size="small"
              {...methods.register("password", {
                required: "Απαιτείται κωδικός",
                pattern: {
                  value: PASSWORD_REGEX,
                  message:
                    "Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες, " +
                    "1 πεζό, 1 κεφαλαίο, 1 αριθμό και 1 ειδικό σύμβολο " +
                    "από το σύνολο: ! @ # $ % ^ & * ( ) _ + - = [ ] { } | ; : ' , . < > / ?",
                },
              })}
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPass((v) => !v)}>
                      {showPass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {/* Confirm Password */}
          <Grid item xs={12} md={6}>
            <TextInput
              type={showPass2 ? "text" : "password"}
              label="Επιβεβαίωση Κωδικού"
              fullWidth
              size="small"
              {...methods.register("confirmPassword", {
                required: "Απαιτείται επιβεβαίωση",
              })}
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPass2((v) => !v)}>
                      {showPass2 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Collapse in={!!error}>
          <Alert
            sx={{ marginTop: 4 }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError("");
                }}
              >
                <Close fontSize="inherit" />
              </IconButton>
            }
            variant="filled"
            severity="error"
          >
            <div dangerouslySetInnerHTML={createMarkup(error)} />
          </Alert>
        </Collapse>
        {/* Submit button */}
        <Grid sx={{ width: "100%" }} item>
          <LoadingButton
            variant="contained"
            startIcon={<Login />}
            loading={loading}
            sx={{ marginTop: 6, mx: "auto" }}
            onClick={handleSubmit(onSubmit)}
          >
            Δημιουργία Λογαριασμού
          </LoadingButton>
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default EmployeeRegisterForm;
